import type { FC } from 'react';

interface IconHorizontalDotsProps {
  className?: string;
  fill?: boolean;
  duotone?: boolean;
}

const IconHorizontalDots: FC<IconHorizontalDotsProps> = ({
  className,
  fill = false,
  duotone = true,
}) => {
  return !fill ? (
    <svg
      width='20'
      height='20'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <circle cx='5' cy='12' r='2' stroke='currentColor' strokeWidth='1.5' />
      <circle
        opacity={duotone ? '0.5' : '1'}
        cx='12'
        cy='12'
        r='2'
        stroke='currentColor'
        strokeWidth='1.5'
      />
      <circle cx='19' cy='12' r='2' stroke='currentColor' strokeWidth='1.5' />
    </svg>
  ) : (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12Z'
        fill='currentColor'
      />
      <path
        d='M21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12Z'
        fill='currentColor'
      />
      <path
        opacity={duotone ? '0.5' : '1'}
        d='M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default IconHorizontalDots;
